import { useEffect, useState } from "react";
import styled from "styled-components";

const LinkedInSuccessPage = () => {
  const [status, setStatus] = useState(null);
  const [token, setToken] = useState(null);

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const status = params.get("status");
  const token = params.get("token");

  if (status === "100" && token) {
    // ✅ Send token back to React Native WebView
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ status: 100, token }));
    } else {
      // ✅ If opened in normal browser, redirect or show success
    //   window.location.href = "/success";
    }
  } else if (status) {
    // Send failure status to RN if present
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ status: Number(status) }));
    }
  }


}, []);

  return (
    <Container>
      {status === null ? (
        <Loader>
          <Spinner />
          <LoadingText>Processing LinkedIn login...</LoadingText>
        </Loader>
      ) : status === "100" ? (
        <SuccessBox>
          <SuccessIcon>✅</SuccessIcon>
          <Title>Login Successful</Title>
          <Message>You can now close this window.</Message>
        </SuccessBox>
      ) : (
        <ErrorBox>
          <ErrorIcon>❌</ErrorIcon>
          <Title>Login Failed</Title>
          <Message>Please try again or contact support.</Message>
        </ErrorBox>
      )}
    </Container>
  );
};

export default LinkedInSuccessPage;

// ✅ Styled Components
const Container = styled.div`
  background-color: #000;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  flex-direction: column;
  padding: 20px;
`;

const Loader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #333;
  border-top: 4px solid #0077b5;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.p`
  font-size: 16px;
  color: #aaa;
`;

const SuccessBox = styled.div`
  text-align: center;
`;

const ErrorBox = styled.div`
  text-align: center;
`;

const SuccessIcon = styled.div`
  font-size: 48px;
  margin-bottom: 10px;
`;

const ErrorIcon = styled.div`
  font-size: 48px;
  margin-bottom: 10px;
`;

const Title = styled.h2`
  font-size: 28px;
  color: #00a0dc;
`;

const Message = styled.p`
  font-size: 16px;
  color: #aaa;
  margin-top: 10px;
`;
